/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_Clients_DescriptionInputs */

const en_users_form_clients_description = /** @type {(inputs: Users_Form_Clients_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This user can view client details and case information for each associated client.`)
};

const pt_br2_users_form_clients_description = /** @type {(inputs: Users_Form_Clients_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este usuário poderá ver os detalhes do cliente e as informações dos casos de cada cliente associado.`)
};

/**
* | output |
* | --- |
* | "This user can view client details and case information for each associated client." |
*
* @param {Users_Form_Clients_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_clients_description = /** @type {((inputs?: Users_Form_Clients_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Clients_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_clients_description(inputs)
	return pt_br2_users_form_clients_description(inputs)
});